import { ContactFilter, ContactSort } from '#app/__generated__/api.js';
import {
  type NetworkTableFilters,
  SortByOptions,
} from '../context/NetworkTableV2FiltersContext.js';
import { NetworkTableColumns } from './types.js';

export const networkTableFilterPopoverOffset = {
  alignOffset: 0,
  sideOffset: 18,
} as const;

export const validNetworkColumns: NetworkTableColumns[] = [
  'CONTRACTOR',
  'TAGS',
  'RATE',
  'SKILLS_AND_TOOLS',
  'RECENT_PROJECTS',
  'WORKED_WITH',
  'ADDED_BY',
  'LOCATION',
];

export const basicNetworkColumns: NetworkTableColumns[] = [
  'CONTRACTOR',
  'TAGS',
];

export const basicNetworkColumnsToHide: NetworkTableColumns[] = [
  'LOCATION',
  'ADDED_BY',
];

export const networkColumnLabels: Record<NetworkTableColumns, string> = {
  ADDED_BY: 'Added by',
  CONTRACTOR: 'Contractor',
  LOCATION: 'Location',
  RATE: 'Rate',
  RECENT_PROJECTS: 'Current projects',
  SKILLS_AND_TOOLS: 'Skills and tools',
  TAGS: 'Tags',
  WORKED_WITH: 'Worked with',
};
const nonCustomizableColumns: NetworkTableColumns[] = ['CONTRACTOR'];
export const validCustomizableColumns = validNetworkColumns.filter(
  (name) => !nonCustomizableColumns.includes(name),
);

const initiallyHiddenColumns: NetworkTableColumns[] = ['ADDED_BY'];

export const defaultCustomization = validNetworkColumns.map((name, index) => ({
  isCustomizable: validCustomizableColumns.includes(name),
  isVisible: !initiallyHiddenColumns.includes(name),
  label: networkColumnLabels[name],
  name,
  sortOrder: index,
}));

export const sortByToSortOption: Record<SortByOptions[number], ContactSort> = {
  'A-Z': {
    direction: 'ASC',
    field: 'FULL_NAME',
    sortByRelevance: false,
  },
  ACTIVE: {
    direction: undefined,
    field: undefined,
    sortByRelevance: true,
  },
  NEWEST: {
    direction: 'DESC',
    field: 'CREATED_AT',
    sortByRelevance: false,
  },
  OLDEST: {
    direction: 'ASC',
    field: 'CREATED_AT',
    sortByRelevance: false,
  },
  'Z-A': {
    direction: 'DESC',
    field: 'FULL_NAME',
    sortByRelevance: false,
  },
} as const;

export const mapContactTableFilterToAPIFilter = (
  filter: NetworkTableFilters,
): ContactFilter => {
  return {
    addedBy: filter.addedBy,
    archived: filter.archived === 'true',
    hourlyRate:
      filter.maxHourlyRate || filter.minHourlyRate
        ? { max: filter.maxHourlyRate, min: filter.minHourlyRate }
        : undefined,
    locationGooglePlaceForeignIds: filter.locations,
    projects: filter.projects,
    roles: filter.roles,
    search: filter.search,
    tags: filter.tags,
    tools: filter.tools,
    userListId: filter.selectedUserList,
    workedWith: filter.workedWith,
  };
};

export const NETWORK_TABLE_PAGE_SIZE = 20;
